<template>
  <div class="go-back" @click="toBack"><img src="../../static/images/zuo.png" /></div>
</template>

<script>
export default {
  data() {
    return {}
  },
  methods: {
    toBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style></style>
